import React, { useEffect, createElement } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { SiteLayout } from './components/SiteLayout';
// Pages
import { HomePage } from './pages/HomePage';
import { ServicesPage } from './pages/ServicesPage';
import { ProcessPage } from './pages/ProcessPage';
import { ResultsPage } from './pages/ResultsPage';
import { FAQPage } from './pages/FAQPage';
import { ContactPage } from './pages/ContactPage';
import { CheckoutPage } from './pages/CheckoutPage';
import { PrivacyPage } from './pages/PrivacyPage';
import { TermsPage } from './pages/TermsPage';
const FAVICON_URL = 'https://cdn.magicpatterns.com/uploads/4Z9hCxF9GbFsHJdtqTcfuJ/Captura_de_pantalla_2026-05-21_a_las_16.06.43.png';
export function App() {
  // Set browser tab title and favicon
  useEffect(() => {
    document.title = 'Growthly Corporation Systems';
    let description = document.querySelector<HTMLMetaElement>('meta[name="description"]');
    if (!description) {
      description = document.createElement('meta');
      description.name = 'description';
      document.head.appendChild(description);
    }
    description.content = 'Growthly Corporation Systems diseña la presencia digital de negocios que quieren verse tan bien como trabajan.';
    const setFavicon = (rel: string) => {
      let link = document.querySelector<HTMLLinkElement>(`link[rel="${rel}"]`);
      if (!link) {
        link = document.createElement('link');
        link.rel = rel;
        document.head.appendChild(link);
      }
      link.type = 'image/png';
      link.href = FAVICON_URL;
    };
    setFavicon('icon');
    setFavicon('shortcut icon');
    setFavicon('apple-touch-icon');
  }, []);
  return <Router data-id="element-0" data-mp="3dlwa6guh8ldp">
      <div className="min-h-screen bg-black font-sans text-gray-100 selection:bg-white selection:text-black" data-id="element-1" data-mp="3dmfqjt4hb1pm">
        <SiteLayout data-id="element-2" data-mp="nvartrdc3fg4">
          <Routes data-id="element-3" data-mp="nxx0jubyo0zx">
            <Route path="/" element={<HomePage data-id="element-5" data-mp="stko65asom3b" />} data-id="element-4" data-mp="sudoanf90dch" />
            <Route path="/servicios" element={<ServicesPage data-id="element-7" data-mp="36hvn4muyo06" />} data-id="element-6" data-mp="sssr0q1jugax" />
            <Route path="/proceso" element={<ProcessPage data-id="element-9" data-mp="34nb3rfi0xwm" />} data-id="element-8" data-mp="35gkz19r83iz" />
            <Route path="/resultados" element={<ResultsPage data-id="element-11" data-mp="3udkqq75thefo" />} data-id="element-10" data-mp="3uct25gan0gyw" />
            <Route path="/faq" element={<FAQPage data-id="element-13" data-mp="3uf5lnxw1mze2" />} data-id="element-12" data-mp="3ucjbrrlok7so" />
            <Route path="/contacto" element={<ContactPage data-id="element-15" data-mp="d45sc040y5kz" />} data-id="element-14" data-mp="d57fh2ybeij2" />
            <Route path="/checkout" element={<CheckoutPage data-id="element-17" data-mp="851m9icecnyv" />} data-id="element-16" data-mp="d2bj3j2481wq" />
            <Route path="/privacidad" element={<PrivacyPage data-id="element-19" data-mp="83qhbf77ta66" />} data-id="element-18" data-mp="86w3omoglxy7" />
            <Route path="/terminos" element={<TermsPage data-id="element-21" data-mp="3gm61hilbgh06" />} data-id="element-20" data-mp="3gkv2dw2tfxfe" />
          </Routes>
        </SiteLayout>
      </div>
    </Router>;
}